import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Introduction() {
  return (
    <div>
      <Typography variant='h2'>Measure What Matters</Typography>
      <Typography gutterBottom align='justify'>
        Compiled data on supports and services for persons with disabilities 
        is currently limited in Canada. This creates difficulties in 
        understanding the extent to which provinces are meeting the needs of 
        Canadians with disabilities, and how Canada is meeting its 
        commitments under the UN Convention on the Rights of Persons with 
        Disabilities. To address this data gap, the Social Policy and Health 
        Team at the School of Public Policy has compiled a database of 
        expenditures (real 2017 $CDN) on and caseloads for supports and services 
        for persons with disabilities in each Canadian province from fiscal year 
        1999/00 (represented as year 2000 below) to present (where available). 
        This data is presented below. Please note that there are many other 
        programs for persons with disabilities that exist in each province; 
        however, we were not able to include them in our database as we could 
        not obtain their associated expenditure and/or caseload data. UN CRPD 
        articles met reflects programs with available expenditure and/or 
        caseload data. Other programs not included in our database may meet 
        requirements under the various articles.
      </Typography>
      <Typography align='justify'>
        Note: Expenditures on and caseloads for special education programs are 
        not included on this website.
      </Typography>
    </div>
  );
}
